import dataApi from '../'

export default {

  /**
  * Get location overview
  */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/location/overview',
      params: params
    })
  },

  /**
  * Get locations based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/location/search',
      params: params
    })
  },

  /**
  * Delete unit
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/location/delete',
      params: params
    })
  },

  /**
  * Get the unit info for edit
  */
  getInforForEdit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/location/info-for-edit',
      params: params
    })
  },

  /**
  * Add unit
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/location/add',
      body: params
    })
  },

  /**
  * Edit unit
  */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/location/edit',
      body: params
    })
  },

  /**
  * Get countries
  */
  getCountries (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/location/countries',
      params: params
    })
  },

  /**
  * Get timezones
  */
  getTimeZones (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/location/time-zones',
      params: params
    })
  },

  /**
   * Get states
   */
  getStates (id) {
    return dataApi.request({
      method: 'get',
      url: 'ui/location/countries/' + id + '/states'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/location.js